import { PAYPAL_PAYMENT_SUCCESS, PAYPAL_PAYMENT_ERROR } from '../../constants/ActionTypes';

const initialState = {
  paymentDetails: null,
  error: null,
  isSuccess: false
};

const PaypalReducer = (state = initialState, action) => {
  switch (action.type) {
    case PAYPAL_PAYMENT_SUCCESS:
      return {
        ...state,
        paymentDetails: action.payload,
        error: null,
        isSuccess: true
      };
    case PAYPAL_PAYMENT_ERROR:
      return {
        ...state,
        paymentDetails: null,
        error: action.payload,
        isSuccess: false
      };
    default:
      return state;
  }
};

export default PaypalReducer;